/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useLazyQuery } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { GET_DEVOULUTION_PAGE_CONFIGS } from './graphql';

export function useGetDevolutionPageConfigs({ storeId } = {}) {
  const { setErrorMessage } = useContext(GeneralContext);
  const [loading, setLoading] = useState(false);
  const [configs, setConfigs] = useState({
    backgroundColor: '',
    headerFooterColor: '',
    primaryColor: '',
    secondaryColor: '',
    fontColor: '',
    fontColorSecondary: '',
    footerIconsColor: '',
    fontFamily: '',
    logoUrl: '',
    faviconUrl: '',
    mainImageUrl: '',
    mainImageMobileUrl: '',
    instagramAccount: '',
    facebookAccount: '',
    linkedinAccount: '',
    tiktokAccount: '',
    contactEmail: '',
    link1Title: '',
    link1Url: '',
    link2Title: '',
    link2Url: '',
    mainImageSizingMode: '',
    mainImageMobileSizingMode: '',
    publicPageEndpoint: '',
  });
  const [GetDevolutionPageConfigs] = useLazyQuery(
    GET_DEVOULUTION_PAGE_CONFIGS,
    { fetchPolicy: 'network-only' },
  );

  async function getDevolutionPageConfigs(newStoreId) {
    setLoading(true);
    try {
      const res = await GetDevolutionPageConfigs({
        variables: { storeId: newStoreId || storeId },
      });
      if (res.data.getDevolutionPageConfigs.code === 200) {
        setConfigs({
          ...res.data.getDevolutionPageConfigs.configs,
        });
      }
    } catch (e) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (storeId) {
      getDevolutionPageConfigs(storeId);
    }
  }, [storeId]);

  return {
    getDevolutionPageConfigs,
    configs,
    setConfigs,
    loading,
  };
}
